/* tslint:disable */
/* eslint-disable */
/**
 * ADMIN-SERVICE - REST API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 2.1.0-SNAPSHOT
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { exists } from '../runtime';
import { MetaDataFromJSON, MetaDataToJSON, StringOptionFromJSON, StringOptionToJSON, } from './';
export function LocationOptionsResponseFromJSON(json) {
    return LocationOptionsResponseFromJSONTyped(json, false);
}
export function LocationOptionsResponseFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'nielsenArea': !exists(json, 'nielsenArea') ? undefined : (json['nielsenArea'].map(StringOptionFromJSON)),
        'metaData': !exists(json, 'metaData') ? undefined : MetaDataFromJSON(json['metaData'])
    };
}
export function LocationOptionsResponseToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'nielsenArea': value.nielsenArea === undefined ? undefined : (value.nielsenArea.map(StringOptionToJSON)),
        'metaData': MetaDataToJSON(value.metaData)
    };
}
